import { Suspense } from 'react';
import { Redeem } from '../features';

const RedeemScreen = () => {
    return (
        <Suspense fallback={null}>
            <Redeem />
        </Suspense>
    );
};
export default RedeemScreen;
